// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.34.0
// source: overview-widget.proto

/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Security } from "./candle-data-depot-common";
import { Exchange, exchangeFromJSON, exchangeToJSON } from "./common";
import { CommunityScreenMetadata, FieldType, fieldTypeFromJSON, fieldTypeToJSON, ScreenerField } from "./screener";
import {
  Instrument,
  instrumentFromJSON,
  instrumentToJSON,
  OptionType,
  optionTypeFromJSON,
  optionTypeToJSON,
  Security as Security1,
  SecurityStatus,
  securityStatusFromJSON,
  securityStatusToJSON,
  Segment,
  segmentFromJSON,
  segmentToJSON,
  SettlementIndicator,
  settlementIndicatorFromJSON,
  settlementIndicatorToJSON,
} from "./security";

export const protobufPackage = "com.tick2trade.api.overview";

export enum TechnicalAction {
  TECHNICAL_ACTION_UNKNOWN = 0,
  BUY = 1,
  SELL = 2,
  NEUTRAL = 3,
  UNRECOGNIZED = -1,
}

export function technicalActionFromJSON(object: any): TechnicalAction {
  switch (object) {
    case 0:
    case "TECHNICAL_ACTION_UNKNOWN":
      return TechnicalAction.TECHNICAL_ACTION_UNKNOWN;
    case 1:
    case "BUY":
      return TechnicalAction.BUY;
    case 2:
    case "SELL":
      return TechnicalAction.SELL;
    case 3:
    case "NEUTRAL":
      return TechnicalAction.NEUTRAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TechnicalAction.UNRECOGNIZED;
  }
}

export function technicalActionToJSON(object: TechnicalAction): string {
  switch (object) {
    case TechnicalAction.TECHNICAL_ACTION_UNKNOWN:
      return "TECHNICAL_ACTION_UNKNOWN";
    case TechnicalAction.BUY:
      return "BUY";
    case TechnicalAction.SELL:
      return "SELL";
    case TechnicalAction.NEUTRAL:
      return "NEUTRAL";
    case TechnicalAction.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TechnicalCategory {
  TECHNICAL_CATEGORY_UNKNOWN = 0,
  OSCILLATOR = 1,
  MOVING_AVERAGE = 2,
  UNRECOGNIZED = -1,
}

export function technicalCategoryFromJSON(object: any): TechnicalCategory {
  switch (object) {
    case 0:
    case "TECHNICAL_CATEGORY_UNKNOWN":
      return TechnicalCategory.TECHNICAL_CATEGORY_UNKNOWN;
    case 1:
    case "OSCILLATOR":
      return TechnicalCategory.OSCILLATOR;
    case 2:
    case "MOVING_AVERAGE":
      return TechnicalCategory.MOVING_AVERAGE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TechnicalCategory.UNRECOGNIZED;
  }
}

export function technicalCategoryToJSON(object: TechnicalCategory): string {
  switch (object) {
    case TechnicalCategory.TECHNICAL_CATEGORY_UNKNOWN:
      return "TECHNICAL_CATEGORY_UNKNOWN";
    case TechnicalCategory.OSCILLATOR:
      return "OSCILLATOR";
    case TechnicalCategory.MOVING_AVERAGE:
      return "MOVING_AVERAGE";
    case TechnicalCategory.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Aggregate gauge label (TradingView Strong Sell…Strong Buy bands). */
export enum TechnicalRatingLabel {
  TECHNICAL_RATING_LABEL_UNKNOWN = 0,
  RATING_STRONG_SELL = 1,
  RATING_SELL = 2,
  RATING_NEUTRAL = 3,
  RATING_BUY = 4,
  RATING_STRONG_BUY = 5,
  UNRECOGNIZED = -1,
}

export function technicalRatingLabelFromJSON(object: any): TechnicalRatingLabel {
  switch (object) {
    case 0:
    case "TECHNICAL_RATING_LABEL_UNKNOWN":
      return TechnicalRatingLabel.TECHNICAL_RATING_LABEL_UNKNOWN;
    case 1:
    case "RATING_STRONG_SELL":
      return TechnicalRatingLabel.RATING_STRONG_SELL;
    case 2:
    case "RATING_SELL":
      return TechnicalRatingLabel.RATING_SELL;
    case 3:
    case "RATING_NEUTRAL":
      return TechnicalRatingLabel.RATING_NEUTRAL;
    case 4:
    case "RATING_BUY":
      return TechnicalRatingLabel.RATING_BUY;
    case 5:
    case "RATING_STRONG_BUY":
      return TechnicalRatingLabel.RATING_STRONG_BUY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TechnicalRatingLabel.UNRECOGNIZED;
  }
}

export function technicalRatingLabelToJSON(object: TechnicalRatingLabel): string {
  switch (object) {
    case TechnicalRatingLabel.TECHNICAL_RATING_LABEL_UNKNOWN:
      return "TECHNICAL_RATING_LABEL_UNKNOWN";
    case TechnicalRatingLabel.RATING_STRONG_SELL:
      return "RATING_STRONG_SELL";
    case TechnicalRatingLabel.RATING_SELL:
      return "RATING_SELL";
    case TechnicalRatingLabel.RATING_NEUTRAL:
      return "RATING_NEUTRAL";
    case TechnicalRatingLabel.RATING_BUY:
      return "RATING_BUY";
    case TechnicalRatingLabel.RATING_STRONG_BUY:
      return "RATING_STRONG_BUY";
    case TechnicalRatingLabel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface OverviewWidgetRequest {
  security: Security | undefined;
}

export interface OverviewWidgetResponse {
  security: OverviewWidgetResponse_Security | undefined;
  fieldGroups: OverviewWidgetResponse_FieldGroup[];
  indexComponents: OverviewWidgetResponse_IndexComponent[];
  communityScreens: CommunityScreenMetadata[];
}

export interface OverviewWidgetResponse_Security {
  exchange: Exchange;
  code: string;
  token: number;
  symbol: string;
  name: string;
  displayName: string;
  segment: Segment;
  instrument: Instrument;
  optionType: OptionType;
  securityStatus: SecurityStatus;
  settlementIndicator: SettlementIndicator;
}

export interface OverviewWidgetResponse_Field {
  name: string;
  fieldType: FieldType;
  value: string;
  order: number;
  screenerField: ScreenerField | undefined;
}

export interface OverviewWidgetResponse_FieldGroup {
  name: string;
  fields: OverviewWidgetResponse_Field[];
}

export interface OverviewWidgetResponse_IndexComponent {
  security: Security1 | undefined;
  ltp: number;
  previousClose: number;
  spi: number;
  weightage: number;
}

export interface GetTechnicalsRequest {
  security:
    | Security
    | undefined;
  /** Screener candle TF: "1m" | "5m" | "15m" | "30m" | "1h" | "1D". Empty defaults to "1D". */
  timeframe: string;
}

export interface TechnicalIndicatorResult {
  id: string;
  name: string;
  category: TechnicalCategory;
  value: number;
  hasValue: boolean;
  action: TechnicalAction;
}

export interface PivotLevel {
  id: string;
  name: string;
  classic: number;
  fibonacci: number;
  camarilla: number;
  woodie: number;
  dm: number;
  hasValue: boolean;
}

export interface TechnicalsTimeframeSummary {
  /** Display id: "15m", "30m", "1h", "1D" */
  timeframe: string;
  oscillators: TechnicalRatingLabel;
  movingAverages: TechnicalRatingLabel;
  summary: TechnicalRatingLabel;
  oscillatorsScore: number;
  movingAveragesScore: number;
  summaryScore: number;
}

export interface GetTechnicalsResponse {
  /** Oscillators, MAs, pivots, and gauges are for detail_timeframe (requested TF). */
  oscillators: TechnicalIndicatorResult[];
  movingAverages: TechnicalIndicatorResult[];
  pivots: PivotLevel[];
  lastClose: number;
  hasLastClose: boolean;
  /** Deprecated: kept for wire compatibility; not populated when client selects a single TF. */
  timeframeSummaries: TechnicalsTimeframeSummary[];
  detailTimeframe: string;
}

function createBaseOverviewWidgetRequest(): OverviewWidgetRequest {
  return { security: undefined };
}

export const OverviewWidgetRequest = {
  encode(message: OverviewWidgetRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverviewWidgetRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverviewWidgetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OverviewWidgetRequest {
    return { security: isSet(object.security) ? Security.fromJSON(object.security) : undefined };
  },

  toJSON(message: OverviewWidgetRequest): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OverviewWidgetRequest>, I>>(base?: I): OverviewWidgetRequest {
    return OverviewWidgetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverviewWidgetRequest>, I>>(object: I): OverviewWidgetRequest {
    const message = createBaseOverviewWidgetRequest();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    return message;
  },
};

function createBaseOverviewWidgetResponse(): OverviewWidgetResponse {
  return { security: undefined, fieldGroups: [], indexComponents: [], communityScreens: [] };
}

export const OverviewWidgetResponse = {
  encode(message: OverviewWidgetResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      OverviewWidgetResponse_Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.fieldGroups) {
      OverviewWidgetResponse_FieldGroup.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.indexComponents) {
      OverviewWidgetResponse_IndexComponent.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.communityScreens) {
      CommunityScreenMetadata.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverviewWidgetResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverviewWidgetResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = OverviewWidgetResponse_Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.fieldGroups.push(OverviewWidgetResponse_FieldGroup.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.indexComponents.push(OverviewWidgetResponse_IndexComponent.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.communityScreens.push(CommunityScreenMetadata.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OverviewWidgetResponse {
    return {
      security: isSet(object.security) ? OverviewWidgetResponse_Security.fromJSON(object.security) : undefined,
      fieldGroups: globalThis.Array.isArray(object?.fieldGroups)
        ? object.fieldGroups.map((e: any) => OverviewWidgetResponse_FieldGroup.fromJSON(e))
        : [],
      indexComponents: globalThis.Array.isArray(object?.indexComponents)
        ? object.indexComponents.map((e: any) => OverviewWidgetResponse_IndexComponent.fromJSON(e))
        : [],
      communityScreens: globalThis.Array.isArray(object?.communityScreens)
        ? object.communityScreens.map((e: any) => CommunityScreenMetadata.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OverviewWidgetResponse): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = OverviewWidgetResponse_Security.toJSON(message.security);
    }
    if (message.fieldGroups?.length) {
      obj.fieldGroups = message.fieldGroups.map((e) => OverviewWidgetResponse_FieldGroup.toJSON(e));
    }
    if (message.indexComponents?.length) {
      obj.indexComponents = message.indexComponents.map((e) => OverviewWidgetResponse_IndexComponent.toJSON(e));
    }
    if (message.communityScreens?.length) {
      obj.communityScreens = message.communityScreens.map((e) => CommunityScreenMetadata.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OverviewWidgetResponse>, I>>(base?: I): OverviewWidgetResponse {
    return OverviewWidgetResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverviewWidgetResponse>, I>>(object: I): OverviewWidgetResponse {
    const message = createBaseOverviewWidgetResponse();
    message.security = (object.security !== undefined && object.security !== null)
      ? OverviewWidgetResponse_Security.fromPartial(object.security)
      : undefined;
    message.fieldGroups = object.fieldGroups?.map((e) => OverviewWidgetResponse_FieldGroup.fromPartial(e)) || [];
    message.indexComponents =
      object.indexComponents?.map((e) => OverviewWidgetResponse_IndexComponent.fromPartial(e)) || [];
    message.communityScreens = object.communityScreens?.map((e) => CommunityScreenMetadata.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOverviewWidgetResponse_Security(): OverviewWidgetResponse_Security {
  return {
    exchange: 0,
    code: "",
    token: 0,
    symbol: "",
    name: "",
    displayName: "",
    segment: 0,
    instrument: 0,
    optionType: 0,
    securityStatus: 0,
    settlementIndicator: 0,
  };
}

export const OverviewWidgetResponse_Security = {
  encode(message: OverviewWidgetResponse_Security, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    if (message.token !== 0) {
      writer.uint32(24).int32(message.token);
    }
    if (message.symbol !== "") {
      writer.uint32(34).string(message.symbol);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.displayName !== "") {
      writer.uint32(50).string(message.displayName);
    }
    if (message.segment !== 0) {
      writer.uint32(64).int32(message.segment);
    }
    if (message.instrument !== 0) {
      writer.uint32(80).int32(message.instrument);
    }
    if (message.optionType !== 0) {
      writer.uint32(112).int32(message.optionType);
    }
    if (message.securityStatus !== 0) {
      writer.uint32(144).int32(message.securityStatus);
    }
    if (message.settlementIndicator !== 0) {
      writer.uint32(160).int32(message.settlementIndicator);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverviewWidgetResponse_Security {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverviewWidgetResponse_Security();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.token = reader.int32();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.symbol = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.displayName = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.segment = reader.int32() as any;
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.instrument = reader.int32() as any;
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.optionType = reader.int32() as any;
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.securityStatus = reader.int32() as any;
          continue;
        case 20:
          if (tag !== 160) {
            break;
          }

          message.settlementIndicator = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OverviewWidgetResponse_Security {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      token: isSet(object.token) ? globalThis.Number(object.token) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
      segment: isSet(object.segment) ? segmentFromJSON(object.segment) : 0,
      instrument: isSet(object.instrument) ? instrumentFromJSON(object.instrument) : 0,
      optionType: isSet(object.optionType) ? optionTypeFromJSON(object.optionType) : 0,
      securityStatus: isSet(object.securityStatus) ? securityStatusFromJSON(object.securityStatus) : 0,
      settlementIndicator: isSet(object.settlementIndicator)
        ? settlementIndicatorFromJSON(object.settlementIndicator)
        : 0,
    };
  },

  toJSON(message: OverviewWidgetResponse_Security): unknown {
    const obj: any = {};
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.token !== 0) {
      obj.token = Math.round(message.token);
    }
    if (message.symbol !== "") {
      obj.symbol = message.symbol;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.segment !== 0) {
      obj.segment = segmentToJSON(message.segment);
    }
    if (message.instrument !== 0) {
      obj.instrument = instrumentToJSON(message.instrument);
    }
    if (message.optionType !== 0) {
      obj.optionType = optionTypeToJSON(message.optionType);
    }
    if (message.securityStatus !== 0) {
      obj.securityStatus = securityStatusToJSON(message.securityStatus);
    }
    if (message.settlementIndicator !== 0) {
      obj.settlementIndicator = settlementIndicatorToJSON(message.settlementIndicator);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OverviewWidgetResponse_Security>, I>>(base?: I): OverviewWidgetResponse_Security {
    return OverviewWidgetResponse_Security.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverviewWidgetResponse_Security>, I>>(
    object: I,
  ): OverviewWidgetResponse_Security {
    const message = createBaseOverviewWidgetResponse_Security();
    message.exchange = object.exchange ?? 0;
    message.code = object.code ?? "";
    message.token = object.token ?? 0;
    message.symbol = object.symbol ?? "";
    message.name = object.name ?? "";
    message.displayName = object.displayName ?? "";
    message.segment = object.segment ?? 0;
    message.instrument = object.instrument ?? 0;
    message.optionType = object.optionType ?? 0;
    message.securityStatus = object.securityStatus ?? 0;
    message.settlementIndicator = object.settlementIndicator ?? 0;
    return message;
  },
};

function createBaseOverviewWidgetResponse_Field(): OverviewWidgetResponse_Field {
  return { name: "", fieldType: 0, value: "", order: 0, screenerField: undefined };
}

export const OverviewWidgetResponse_Field = {
  encode(message: OverviewWidgetResponse_Field, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.fieldType !== 0) {
      writer.uint32(24).int32(message.fieldType);
    }
    if (message.value !== "") {
      writer.uint32(42).string(message.value);
    }
    if (message.order !== 0) {
      writer.uint32(48).int32(message.order);
    }
    if (message.screenerField !== undefined) {
      ScreenerField.encode(message.screenerField, writer.uint32(58).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverviewWidgetResponse_Field {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverviewWidgetResponse_Field();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.fieldType = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.value = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.order = reader.int32();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.screenerField = ScreenerField.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OverviewWidgetResponse_Field {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      fieldType: isSet(object.fieldType) ? fieldTypeFromJSON(object.fieldType) : 0,
      value: isSet(object.value) ? globalThis.String(object.value) : "",
      order: isSet(object.order) ? globalThis.Number(object.order) : 0,
      screenerField: isSet(object.screenerField) ? ScreenerField.fromJSON(object.screenerField) : undefined,
    };
  },

  toJSON(message: OverviewWidgetResponse_Field): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.fieldType !== 0) {
      obj.fieldType = fieldTypeToJSON(message.fieldType);
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    if (message.order !== 0) {
      obj.order = Math.round(message.order);
    }
    if (message.screenerField !== undefined) {
      obj.screenerField = ScreenerField.toJSON(message.screenerField);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OverviewWidgetResponse_Field>, I>>(base?: I): OverviewWidgetResponse_Field {
    return OverviewWidgetResponse_Field.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverviewWidgetResponse_Field>, I>>(object: I): OverviewWidgetResponse_Field {
    const message = createBaseOverviewWidgetResponse_Field();
    message.name = object.name ?? "";
    message.fieldType = object.fieldType ?? 0;
    message.value = object.value ?? "";
    message.order = object.order ?? 0;
    message.screenerField = (object.screenerField !== undefined && object.screenerField !== null)
      ? ScreenerField.fromPartial(object.screenerField)
      : undefined;
    return message;
  },
};

function createBaseOverviewWidgetResponse_FieldGroup(): OverviewWidgetResponse_FieldGroup {
  return { name: "", fields: [] };
}

export const OverviewWidgetResponse_FieldGroup = {
  encode(message: OverviewWidgetResponse_FieldGroup, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    for (const v of message.fields) {
      OverviewWidgetResponse_Field.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverviewWidgetResponse_FieldGroup {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverviewWidgetResponse_FieldGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.fields.push(OverviewWidgetResponse_Field.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OverviewWidgetResponse_FieldGroup {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      fields: globalThis.Array.isArray(object?.fields)
        ? object.fields.map((e: any) => OverviewWidgetResponse_Field.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OverviewWidgetResponse_FieldGroup): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.fields?.length) {
      obj.fields = message.fields.map((e) => OverviewWidgetResponse_Field.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OverviewWidgetResponse_FieldGroup>, I>>(
    base?: I,
  ): OverviewWidgetResponse_FieldGroup {
    return OverviewWidgetResponse_FieldGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverviewWidgetResponse_FieldGroup>, I>>(
    object: I,
  ): OverviewWidgetResponse_FieldGroup {
    const message = createBaseOverviewWidgetResponse_FieldGroup();
    message.name = object.name ?? "";
    message.fields = object.fields?.map((e) => OverviewWidgetResponse_Field.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOverviewWidgetResponse_IndexComponent(): OverviewWidgetResponse_IndexComponent {
  return { security: undefined, ltp: 0, previousClose: 0, spi: 0, weightage: 0 };
}

export const OverviewWidgetResponse_IndexComponent = {
  encode(message: OverviewWidgetResponse_IndexComponent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security1.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.ltp !== 0) {
      writer.uint32(24).int32(message.ltp);
    }
    if (message.previousClose !== 0) {
      writer.uint32(40).int32(message.previousClose);
    }
    if (message.spi !== 0) {
      writer.uint32(49).double(message.spi);
    }
    if (message.weightage !== 0) {
      writer.uint32(65).double(message.weightage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverviewWidgetResponse_IndexComponent {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverviewWidgetResponse_IndexComponent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security1.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.ltp = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.previousClose = reader.int32();
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.spi = reader.double();
          continue;
        case 8:
          if (tag !== 65) {
            break;
          }

          message.weightage = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OverviewWidgetResponse_IndexComponent {
    return {
      security: isSet(object.security) ? Security1.fromJSON(object.security) : undefined,
      ltp: isSet(object.ltp) ? globalThis.Number(object.ltp) : 0,
      previousClose: isSet(object.previousClose) ? globalThis.Number(object.previousClose) : 0,
      spi: isSet(object.spi) ? globalThis.Number(object.spi) : 0,
      weightage: isSet(object.weightage) ? globalThis.Number(object.weightage) : 0,
    };
  },

  toJSON(message: OverviewWidgetResponse_IndexComponent): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security1.toJSON(message.security);
    }
    if (message.ltp !== 0) {
      obj.ltp = Math.round(message.ltp);
    }
    if (message.previousClose !== 0) {
      obj.previousClose = Math.round(message.previousClose);
    }
    if (message.spi !== 0) {
      obj.spi = message.spi;
    }
    if (message.weightage !== 0) {
      obj.weightage = message.weightage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OverviewWidgetResponse_IndexComponent>, I>>(
    base?: I,
  ): OverviewWidgetResponse_IndexComponent {
    return OverviewWidgetResponse_IndexComponent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverviewWidgetResponse_IndexComponent>, I>>(
    object: I,
  ): OverviewWidgetResponse_IndexComponent {
    const message = createBaseOverviewWidgetResponse_IndexComponent();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security1.fromPartial(object.security)
      : undefined;
    message.ltp = object.ltp ?? 0;
    message.previousClose = object.previousClose ?? 0;
    message.spi = object.spi ?? 0;
    message.weightage = object.weightage ?? 0;
    return message;
  },
};

function createBaseGetTechnicalsRequest(): GetTechnicalsRequest {
  return { security: undefined, timeframe: "" };
}

export const GetTechnicalsRequest = {
  encode(message: GetTechnicalsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.timeframe !== "") {
      writer.uint32(18).string(message.timeframe);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetTechnicalsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTechnicalsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.timeframe = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTechnicalsRequest {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      timeframe: isSet(object.timeframe) ? globalThis.String(object.timeframe) : "",
    };
  },

  toJSON(message: GetTechnicalsRequest): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.timeframe !== "") {
      obj.timeframe = message.timeframe;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTechnicalsRequest>, I>>(base?: I): GetTechnicalsRequest {
    return GetTechnicalsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTechnicalsRequest>, I>>(object: I): GetTechnicalsRequest {
    const message = createBaseGetTechnicalsRequest();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.timeframe = object.timeframe ?? "";
    return message;
  },
};

function createBaseTechnicalIndicatorResult(): TechnicalIndicatorResult {
  return { id: "", name: "", category: 0, value: 0, hasValue: false, action: 0 };
}

export const TechnicalIndicatorResult = {
  encode(message: TechnicalIndicatorResult, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.value !== 0) {
      writer.uint32(33).double(message.value);
    }
    if (message.hasValue !== false) {
      writer.uint32(40).bool(message.hasValue);
    }
    if (message.action !== 0) {
      writer.uint32(48).int32(message.action);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TechnicalIndicatorResult {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTechnicalIndicatorResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.value = reader.double();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.hasValue = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.action = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TechnicalIndicatorResult {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      category: isSet(object.category) ? technicalCategoryFromJSON(object.category) : 0,
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
      hasValue: isSet(object.hasValue) ? globalThis.Boolean(object.hasValue) : false,
      action: isSet(object.action) ? technicalActionFromJSON(object.action) : 0,
    };
  },

  toJSON(message: TechnicalIndicatorResult): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.category !== 0) {
      obj.category = technicalCategoryToJSON(message.category);
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    if (message.hasValue !== false) {
      obj.hasValue = message.hasValue;
    }
    if (message.action !== 0) {
      obj.action = technicalActionToJSON(message.action);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TechnicalIndicatorResult>, I>>(base?: I): TechnicalIndicatorResult {
    return TechnicalIndicatorResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TechnicalIndicatorResult>, I>>(object: I): TechnicalIndicatorResult {
    const message = createBaseTechnicalIndicatorResult();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.category = object.category ?? 0;
    message.value = object.value ?? 0;
    message.hasValue = object.hasValue ?? false;
    message.action = object.action ?? 0;
    return message;
  },
};

function createBasePivotLevel(): PivotLevel {
  return { id: "", name: "", classic: 0, fibonacci: 0, camarilla: 0, woodie: 0, dm: 0, hasValue: false };
}

export const PivotLevel = {
  encode(message: PivotLevel, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.classic !== 0) {
      writer.uint32(25).double(message.classic);
    }
    if (message.fibonacci !== 0) {
      writer.uint32(33).double(message.fibonacci);
    }
    if (message.camarilla !== 0) {
      writer.uint32(41).double(message.camarilla);
    }
    if (message.woodie !== 0) {
      writer.uint32(49).double(message.woodie);
    }
    if (message.dm !== 0) {
      writer.uint32(57).double(message.dm);
    }
    if (message.hasValue !== false) {
      writer.uint32(64).bool(message.hasValue);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PivotLevel {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePivotLevel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.classic = reader.double();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.fibonacci = reader.double();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.camarilla = reader.double();
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.woodie = reader.double();
          continue;
        case 7:
          if (tag !== 57) {
            break;
          }

          message.dm = reader.double();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.hasValue = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PivotLevel {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      classic: isSet(object.classic) ? globalThis.Number(object.classic) : 0,
      fibonacci: isSet(object.fibonacci) ? globalThis.Number(object.fibonacci) : 0,
      camarilla: isSet(object.camarilla) ? globalThis.Number(object.camarilla) : 0,
      woodie: isSet(object.woodie) ? globalThis.Number(object.woodie) : 0,
      dm: isSet(object.dm) ? globalThis.Number(object.dm) : 0,
      hasValue: isSet(object.hasValue) ? globalThis.Boolean(object.hasValue) : false,
    };
  },

  toJSON(message: PivotLevel): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.classic !== 0) {
      obj.classic = message.classic;
    }
    if (message.fibonacci !== 0) {
      obj.fibonacci = message.fibonacci;
    }
    if (message.camarilla !== 0) {
      obj.camarilla = message.camarilla;
    }
    if (message.woodie !== 0) {
      obj.woodie = message.woodie;
    }
    if (message.dm !== 0) {
      obj.dm = message.dm;
    }
    if (message.hasValue !== false) {
      obj.hasValue = message.hasValue;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PivotLevel>, I>>(base?: I): PivotLevel {
    return PivotLevel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PivotLevel>, I>>(object: I): PivotLevel {
    const message = createBasePivotLevel();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.classic = object.classic ?? 0;
    message.fibonacci = object.fibonacci ?? 0;
    message.camarilla = object.camarilla ?? 0;
    message.woodie = object.woodie ?? 0;
    message.dm = object.dm ?? 0;
    message.hasValue = object.hasValue ?? false;
    return message;
  },
};

function createBaseTechnicalsTimeframeSummary(): TechnicalsTimeframeSummary {
  return {
    timeframe: "",
    oscillators: 0,
    movingAverages: 0,
    summary: 0,
    oscillatorsScore: 0,
    movingAveragesScore: 0,
    summaryScore: 0,
  };
}

export const TechnicalsTimeframeSummary = {
  encode(message: TechnicalsTimeframeSummary, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeframe !== "") {
      writer.uint32(10).string(message.timeframe);
    }
    if (message.oscillators !== 0) {
      writer.uint32(16).int32(message.oscillators);
    }
    if (message.movingAverages !== 0) {
      writer.uint32(24).int32(message.movingAverages);
    }
    if (message.summary !== 0) {
      writer.uint32(32).int32(message.summary);
    }
    if (message.oscillatorsScore !== 0) {
      writer.uint32(41).double(message.oscillatorsScore);
    }
    if (message.movingAveragesScore !== 0) {
      writer.uint32(49).double(message.movingAveragesScore);
    }
    if (message.summaryScore !== 0) {
      writer.uint32(57).double(message.summaryScore);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TechnicalsTimeframeSummary {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTechnicalsTimeframeSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.timeframe = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.oscillators = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.movingAverages = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.summary = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.oscillatorsScore = reader.double();
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.movingAveragesScore = reader.double();
          continue;
        case 7:
          if (tag !== 57) {
            break;
          }

          message.summaryScore = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TechnicalsTimeframeSummary {
    return {
      timeframe: isSet(object.timeframe) ? globalThis.String(object.timeframe) : "",
      oscillators: isSet(object.oscillators) ? technicalRatingLabelFromJSON(object.oscillators) : 0,
      movingAverages: isSet(object.movingAverages) ? technicalRatingLabelFromJSON(object.movingAverages) : 0,
      summary: isSet(object.summary) ? technicalRatingLabelFromJSON(object.summary) : 0,
      oscillatorsScore: isSet(object.oscillatorsScore) ? globalThis.Number(object.oscillatorsScore) : 0,
      movingAveragesScore: isSet(object.movingAveragesScore) ? globalThis.Number(object.movingAveragesScore) : 0,
      summaryScore: isSet(object.summaryScore) ? globalThis.Number(object.summaryScore) : 0,
    };
  },

  toJSON(message: TechnicalsTimeframeSummary): unknown {
    const obj: any = {};
    if (message.timeframe !== "") {
      obj.timeframe = message.timeframe;
    }
    if (message.oscillators !== 0) {
      obj.oscillators = technicalRatingLabelToJSON(message.oscillators);
    }
    if (message.movingAverages !== 0) {
      obj.movingAverages = technicalRatingLabelToJSON(message.movingAverages);
    }
    if (message.summary !== 0) {
      obj.summary = technicalRatingLabelToJSON(message.summary);
    }
    if (message.oscillatorsScore !== 0) {
      obj.oscillatorsScore = message.oscillatorsScore;
    }
    if (message.movingAveragesScore !== 0) {
      obj.movingAveragesScore = message.movingAveragesScore;
    }
    if (message.summaryScore !== 0) {
      obj.summaryScore = message.summaryScore;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TechnicalsTimeframeSummary>, I>>(base?: I): TechnicalsTimeframeSummary {
    return TechnicalsTimeframeSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TechnicalsTimeframeSummary>, I>>(object: I): TechnicalsTimeframeSummary {
    const message = createBaseTechnicalsTimeframeSummary();
    message.timeframe = object.timeframe ?? "";
    message.oscillators = object.oscillators ?? 0;
    message.movingAverages = object.movingAverages ?? 0;
    message.summary = object.summary ?? 0;
    message.oscillatorsScore = object.oscillatorsScore ?? 0;
    message.movingAveragesScore = object.movingAveragesScore ?? 0;
    message.summaryScore = object.summaryScore ?? 0;
    return message;
  },
};

function createBaseGetTechnicalsResponse(): GetTechnicalsResponse {
  return {
    oscillators: [],
    movingAverages: [],
    pivots: [],
    lastClose: 0,
    hasLastClose: false,
    timeframeSummaries: [],
    detailTimeframe: "",
  };
}

export const GetTechnicalsResponse = {
  encode(message: GetTechnicalsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.oscillators) {
      TechnicalIndicatorResult.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.movingAverages) {
      TechnicalIndicatorResult.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.pivots) {
      PivotLevel.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.lastClose !== 0) {
      writer.uint32(33).double(message.lastClose);
    }
    if (message.hasLastClose !== false) {
      writer.uint32(40).bool(message.hasLastClose);
    }
    for (const v of message.timeframeSummaries) {
      TechnicalsTimeframeSummary.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    if (message.detailTimeframe !== "") {
      writer.uint32(58).string(message.detailTimeframe);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetTechnicalsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTechnicalsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.oscillators.push(TechnicalIndicatorResult.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.movingAverages.push(TechnicalIndicatorResult.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.pivots.push(PivotLevel.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.lastClose = reader.double();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.hasLastClose = reader.bool();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.timeframeSummaries.push(TechnicalsTimeframeSummary.decode(reader, reader.uint32()));
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.detailTimeframe = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTechnicalsResponse {
    return {
      oscillators: globalThis.Array.isArray(object?.oscillators)
        ? object.oscillators.map((e: any) => TechnicalIndicatorResult.fromJSON(e))
        : [],
      movingAverages: globalThis.Array.isArray(object?.movingAverages)
        ? object.movingAverages.map((e: any) => TechnicalIndicatorResult.fromJSON(e))
        : [],
      pivots: globalThis.Array.isArray(object?.pivots) ? object.pivots.map((e: any) => PivotLevel.fromJSON(e)) : [],
      lastClose: isSet(object.lastClose) ? globalThis.Number(object.lastClose) : 0,
      hasLastClose: isSet(object.hasLastClose) ? globalThis.Boolean(object.hasLastClose) : false,
      timeframeSummaries: globalThis.Array.isArray(object?.timeframeSummaries)
        ? object.timeframeSummaries.map((e: any) => TechnicalsTimeframeSummary.fromJSON(e))
        : [],
      detailTimeframe: isSet(object.detailTimeframe) ? globalThis.String(object.detailTimeframe) : "",
    };
  },

  toJSON(message: GetTechnicalsResponse): unknown {
    const obj: any = {};
    if (message.oscillators?.length) {
      obj.oscillators = message.oscillators.map((e) => TechnicalIndicatorResult.toJSON(e));
    }
    if (message.movingAverages?.length) {
      obj.movingAverages = message.movingAverages.map((e) => TechnicalIndicatorResult.toJSON(e));
    }
    if (message.pivots?.length) {
      obj.pivots = message.pivots.map((e) => PivotLevel.toJSON(e));
    }
    if (message.lastClose !== 0) {
      obj.lastClose = message.lastClose;
    }
    if (message.hasLastClose !== false) {
      obj.hasLastClose = message.hasLastClose;
    }
    if (message.timeframeSummaries?.length) {
      obj.timeframeSummaries = message.timeframeSummaries.map((e) => TechnicalsTimeframeSummary.toJSON(e));
    }
    if (message.detailTimeframe !== "") {
      obj.detailTimeframe = message.detailTimeframe;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTechnicalsResponse>, I>>(base?: I): GetTechnicalsResponse {
    return GetTechnicalsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTechnicalsResponse>, I>>(object: I): GetTechnicalsResponse {
    const message = createBaseGetTechnicalsResponse();
    message.oscillators = object.oscillators?.map((e) => TechnicalIndicatorResult.fromPartial(e)) || [];
    message.movingAverages = object.movingAverages?.map((e) => TechnicalIndicatorResult.fromPartial(e)) || [];
    message.pivots = object.pivots?.map((e) => PivotLevel.fromPartial(e)) || [];
    message.lastClose = object.lastClose ?? 0;
    message.hasLastClose = object.hasLastClose ?? false;
    message.timeframeSummaries = object.timeframeSummaries?.map((e) => TechnicalsTimeframeSummary.fromPartial(e)) || [];
    message.detailTimeframe = object.detailTimeframe ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
